import { render, staticRenderFns } from "./Jalousie.vue?vue&type=template&id=2c5aa983&lang=pug&"
import script from "./Jalousie.vue?vue&type=script&lang=js&"
export * from "./Jalousie.vue?vue&type=script&lang=js&"
import style0 from "./Jalousie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports